import vtkAppendPolyData from './AppendPolyData';
import vtkCalculator from './Calculator';
import vtkClosedPolyLineToSurfaceFilter from './ClosedPolyLineToSurfaceFilter';
import vtkImageCropFilter from './ImageCropFilter';
import vtkImageMarchingCubes from './ImageMarchingCubes';
import vtkImageMarchingSquares from './ImageMarchingSquares';
import vtkImageOutlineFilter from './ImageOutlineFilter';
import vtkImageSliceFilter from './ImageSliceFilter';
import vtkImageStreamline from './ImageStreamline';
import vtkMoleculeToRepresentation from './MoleculeToRepresentation';
import vtkOBBTree from './OBBTree';
import vtkOutlineFilter from './OutlineFilter';
import vtkPaintFilter from './PaintFilter';
import vtkScalarToRGBA from './ScalarToRGBA';
import vtkTubeFilter from './TubeFilter';
import vtkWarpScalar from './WarpScalar';
import vtkWindowedSincPolyDataFilter from './WindowedSincPolyDataFilter';

export default {
  vtkAppendPolyData,
  vtkCalculator,
  vtkClosedPolyLineToSurfaceFilter,
  vtkImageCropFilter,
  vtkImageMarchingCubes,
  vtkImageMarchingSquares,
  vtkImageOutlineFilter,
  vtkImageSliceFilter,
  vtkImageStreamline,
  vtkMoleculeToRepresentation,
  vtkOBBTree,
  vtkOutlineFilter,
  vtkPaintFilter,
  vtkScalarToRGBA,
  vtkTubeFilter,
  vtkWarpScalar,
  vtkWindowedSincPolyDataFilter,
};
